import {announce} from '@github-ui/aria-live'
import {useRestoreHeadRefMutation} from '@github-ui/mergebox/use-restore-head-ref-mutation'
import {GitPullRequestClosedIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useInvalidatePrState} from '../../data/use-invalidate-pr-state'
import {FailureDialog} from '../../sidebar-actions/FailureDialog'
import {ForYouItem} from '../shared/ForYouItem'

export function RestoreHeadBranch() {
  const invalidatePrState = useInvalidatePrState()
  const restoreHeadRefMutation = useRestoreHeadRefMutation({
    onSuccess: () => {
      announce('Branch restored')
      invalidatePrState()
    },
  })

  return (
    <>
      <ForYouItem
        itemId="restore-branch"
        visual={{kind: 'icon', icon: GitPullRequestClosedIcon, tone: 'neutral', glyphSize: 12}}
        title="Closed"
        subText="Restore the branch if you still need it."
        actions={[
          {
            id: 'restore',
            content: (
              <Button
                size="small"
                loading={restoreHeadRefMutation.isPending}
                loadingAnnouncement="Restoring head branch"
                onClick={() => restoreHeadRefMutation.mutate()}
              >
                Restore branch
              </Button>
            ),
          },
        ]}
      />
      {restoreHeadRefMutation.isError && (
        <FailureDialog
          title="Failed to restore branch"
          message="An error occurred while restoring the branch. Please try again."
          details={restoreHeadRefMutation.error.message}
          onRetry={() => restoreHeadRefMutation.mutate()}
          onDismiss={() => restoreHeadRefMutation.reset()}
        />
      )}
    </>
  )
}
